<template>
	<div class="input-group" :class="inputGroupClasses">
		<div :class="wrapper" data-testid="wrapper">
			<div class="flex gap-3 items-center">
				<input
					:id="id ?? name"
					v-model="model"
					:type="type"
					:name="name"
					:aria-label="name"
					:class="checkboxClasses"
					:disabled="disabled"
					:true-value="trueValue"
					:false-value="falseValue"
					data-testid="input"
					@click.stop />

				<app-label v-if="label" data-testid="label" :field="id ?? name">{{
					label
				}}</app-label>
			</div>

			<p
				v-if="error"
				:id="`${name}-error`"
				data-testid="error-message"
				class="mt-2 text-sm text-red-600">
				{{ error }}
			</p>

			<p
				v-else-if="hint"
				:id="`${name}-description`"
				data-testid="hint"
				class="mt-2 text-sm text-gray-500">
				{{ hint }}
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { computed } from 'vue'
	import { useFieldClasses } from '@/composables/forms'

	const props = withDefaults(
		defineProps<{
			modelValue?: any
			id?: string
			label?: string
			name: string
			trueValue?: string | number | boolean
			falseValue?: string | number | boolean
			hint?: string
			error?: string
			type?: 'checkbox' | 'radio'
			size?: 'small' | 'medium' | 'large'
			theme?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger'
			wrapper?: string
			disabled?: boolean
		}>(),
		{
			modelValue: undefined,
			id: '',
			label: undefined,
			hint: undefined,
			error: undefined,
			theme: 'primary',
			size: 'medium',
			type: 'checkbox',
			wrapper: 'mt-2',
			disabled: false,
			trueValue: true,
			falseValue: false
		}
	)

	// Styles
	const { inputGroupClasses, checkboxClasses } = useFieldClasses(props)

	// Events
	const emit = defineEmits(['update:modelValue'])
	const model = computed({
		get() {
			return props.modelValue
		},
		set(value) {
			emit('update:modelValue', value)
		}
	})
</script>
